module.exports = require('../../full/object/is');
